import { useTranslation } from 'react-i18next';
import { SttList } from '../../sporttia/all';
import type { Discount } from '../../types/models/Discount';

type DiscountListProps = {
    discounts: Discount[];
    showEmptyMessage?: boolean;
    showTitle?: boolean;
    onAdd?: () => void;
    onDelete?: (discount: Discount) => void;
    onSelect?: (discount: Discount) => void;
};

export default function DiscountList({
    discounts,
    showEmptyMessage = true,
    showTitle = true,
    onAdd,
    onDelete,
    onSelect,
}: DiscountListProps) {
    const { t } = useTranslation();

    return discounts.length || showEmptyMessage ? (
        <SttList
            title={showTitle ? t('generic.discounts') : undefined}
            data={discounts.map((discount: Discount) => ({
                caption: `${discount.name} - ${discount.discountPercentage}%`,
                objToSelect: discount,
            }))}
            numRows={5}
            onAdd={onAdd}
            onDelete={onDelete}
            onSelect={onSelect}
        />
    ) : null;
}
